import IconExample from "./examples/Icon.Example";
export default [
    {
        title: "Basic icon",
        component: IconExample,
        code: require("!raw-loader!./examples/Icon.Example.tsx")
    }
];
